import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';
import { deleteRegisterStep } from 'models/user';
import VideoModal from 'components/modals/VideoModal';

const RegisterSuccess = ({ t }) => {
  const [videoUrl, setVideoUrl] = useState('');

  useEffect(() => {
    deleteRegisterStep();
  }, []);

  return (
    <>
      <main className="has-header">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-15 col-sm-6">
              <div className="mh-container">
                <div className="row">
                  <div className="col">
                    <div className="row mb-5">
                      <div className="col text-center">
                        <i className="fa-solid fa-check-circle text-green2 fs-90" />
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col text-center">
                        <div className="fs-22 fw-700">{t('activationCompleted')}</div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col text-center">
                        <p>
                          İkinci el iş makinası alıp satmanın en kolay yolu, iyiMakina.com'a hoş geldiniz.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col mt-4">
                  <div className="row mb-3">
                    <div className="col">
                      <a
                        className="im-button im-button--primary im-button--fluid im-button--center fw-900"
                        onClick={() => setVideoUrl('https://www.youtube.com/embed/ZCeZBGGlVHg?autoplay=1&amp;autohide=1&amp;fs=1&amp;rel=0&amp;hd=1&amp;wmode=transparent&amp;enablejsapi=1&amp;html5=1')}
                      >
                        {t('findOutHowItWorks')}
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Link href="/login">
                        <a className="im-button im-button--transparent im-button--fluid im-button--center fw-900">
                          {t('login')}
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </main>
      <VideoModal
        videoUrl={videoUrl}
        setVideoUrl={setVideoUrl}
      />
    </>
  );
};

RegisterSuccess.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('common')(RegisterSuccess);
